import { useEffect, useMemo, useState } from 'react';
import { useAuthContext } from '../../../agenticsaas/contexts/AuthContext';
import { useOrganizationContext } from '../../../agenticsaas/contexts/OrganizationContext';
import { useOrganization } from '../../../agenticsaas/hooks/useOrganization';
import { customExecutiveMetricsService } from '../../../services/customExecutiveMetricsService';

export function useDashboardBranding({ mode = 'executive' } = {}) {
  const { user } = useAuthContext();
  const { organizationName, organizationId, loading: orgContextLoading } = useOrganizationContext();
  const { organization } = useOrganization();
  const [brandingOverride, setBrandingOverride] = useState({
    dashboardTitle: '',
    dashboardSubtitle: '',
  });

  useEffect(() => {
    if (!organizationId) return;
    let cancelled = false;
    customExecutiveMetricsService.getExecutiveConfig(String(organizationId)).then((config) => {
      if (!cancelled) setBrandingOverride(config.branding || {});
    });
    const onUpdate = () => {
      customExecutiveMetricsService.getExecutiveConfig(String(organizationId)).then((config) => {
        if (!cancelled) setBrandingOverride(config.branding || {});
      });
    };
    window.addEventListener('executive-custom-metrics-updated', onUpdate);
    return () => {
      cancelled = true;
      window.removeEventListener('executive-custom-metrics-updated', onUpdate);
    };
  }, [organizationId]);

  const resolvedOrgName =
    organizationName ||
    organization?.name ||
    organization?.organization_name ||
    '';

  const branding = useMemo(() => {
    const customTitle =
      mode === 'executive'
        ? brandingOverride.dashboardTitle?.trim()
        : mode === 'finance'
          ? brandingOverride.financeDashboardTitle?.trim() || brandingOverride.dashboardTitle?.trim()
          : brandingOverride.operationalDashboardTitle?.trim() || brandingOverride.dashboardTitle?.trim();
    const customSubtitle =
      mode === 'executive'
        ? brandingOverride.dashboardSubtitle?.trim()
        : mode === 'finance'
          ? brandingOverride.financeDashboardSubtitle?.trim() || brandingOverride.dashboardSubtitle?.trim()
          : brandingOverride.operationalDashboardSubtitle?.trim() || brandingOverride.dashboardSubtitle?.trim();

    const defaults = {
      executive: {
        title: 'Enterprise KPI Dashboard',
        subtitle: 'Executive KPI Dashboard',
      },
      finance: {
        title: 'Finance View',
        subtitle: 'Platform financial KPIs from our own books',
      },
      operational: {
        title: 'Operational Dashboard',
        subtitle: 'Work queues, service health, and frontline RCM metrics',
      },
    };
    const d = defaults[mode] || defaults.executive;

    return {
      title: customTitle || resolvedOrgName || d.title,
      subtitle: customSubtitle || (resolvedOrgName ? d.subtitle : d.subtitle),
    };
  }, [brandingOverride, resolvedOrgName, mode]);

  return {
    branding,
    resolvedOrgName,
    organizationId,
    orgContextLoading,
    user,
  };
}
